<template>
	<el-container class="wrapper">
		<el-header class="title">
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/index/product' }">产品管理</el-breadcrumb-item>
						<el-breadcrumb-item >{{product.name}}</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main style="position: relative;padding: 10px !important;" v-loading="operating">
			<el-tabs v-model="activeName" type="border-card" class="card" :before-leave="tabBeforeLeave"  @tab-click="tabOnClick">
				<el-tab-pane label="历史净值" name="nethistory" :style="mainStyleObject">
					<div style="height: 40px;width: 100%;">
						<span style="color: #606266;font-size: 13px;padding: 0 5px;">查询时间:</span>
						<el-date-picker v-model="searchTime" type="daterange"
							align="right"
							unlink-panels
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期" @change="timeOnPick" :clearable="false" :editable="false"
							:picker-options="pickerOptions" size="small" value-format="yyyy-MM-dd">
						</el-date-picker>
						<el-radio-group size="small" v-model="showType">
							<el-radio-button label="图"></el-radio-button>
							<el-radio-button label="表"></el-radio-button>
						</el-radio-group>
						<el-button-group>
							<el-button @click="popNetView()" class="group-btn" size="small" type="primary" icon="el-icon-plus"></el-button>
						</el-button-group>
						<el-button @click="exportExcel()" icon="el-icon-download" type="danger" size="small" style="position: absolute;top: 15px;right:30px;">导出</el-button>
					</div>
					<div v-show="showType=='图'" :style="{width:'100%',height:tableHeight,'overflow-y':'auto'}">
						<div id="productNetChart2" style="width: 45%;height:300px;box-sizing: border-box;margin-top: 20px;display: inline-block;">

						</div>
						<div id="productNetChart3" style="width: 45%;height: 300px;box-sizing: border-box;margin-top: 20px;display: inline-block;margin-left: 2%;">

						</div>
						<div id="productNetChart" style="width: 45%;height: 300px;box-sizing: border-box;margin-top: 20px;display: inline-block;">

						</div>
						<div id="productNetChart1" style="width: 45%;height: 300px;box-sizing: border-box;margin-top: 20px;display: inline-block;margin-left: 2%;">

						</div>
					</div>
					<el-table v-show="showType=='表'" :data="tableData" header-cell-class-name="table_header" lazy
										 :load="load" border :height="tableHeight"
										 :tree-props="{children: 'children', hasChildren: 'hasChildren'}" rowKey="id" :stripe="true">
						<el-table-column prop="valueTime" label="净值时间" :formatter="valueTimeFormatter">
						</el-table-column>
						<el-table-column prop="totalAmount" label="资产净值" width="150px" >
						</el-table-column>
						<el-table-column prop="totalPortion" label="资产份额"  width="150px" >
						</el-table-column>
						<el-table-column prop="netValue" label="单位净值" :formatter="dataFormatter"  width="150px" >
						</el-table-column>
						<el-table-column prop="totalNetValue" label="资产净值" :formatter="dataFormatter"  width="150px" >
						</el-table-column>
						<el-table-column label="操作" width="120px">
							<template slot-scope="scope"  v-if="scope.row.hasChildren">
								<el-button
									size="mini"
									class="el-button--primary" icon="el-icon-edit" circle @click="popUpdateNetView(scope.row)"></el-button>
								<el-button
									size="mini"
									class="el-button--danger" icon="el-icon-delete" circle  @click="deleteNetValue(scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="产品客户列表" name="productcustomer" :style="getStyleObject()">
					<el-table ref="productCustomerTable" :data="productCustomerTableData" header-cell-class-name="table_header" @selection-change="customerSelectChange"
										border :height="productCustomerTableHeight" rowKey="id" :stripe="true">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="customerName" label="客户姓名" width="150px">
						</el-table-column>
						<el-table-column prop="productName" label="产品名称">
						</el-table-column>
						<el-table-column prop="productCategoryName" label="产品类别">
						</el-table-column>
						<el-table-column prop="portion" label="份额" width="150px">
						</el-table-column>
						<el-table-column prop="firstBuyTime" label="购买日期" width="150px" :formatter="dateFormatter">
						</el-table-column>
					</el-table>
					<div class="bottom-bar">
						<div style="position: absolute;top: 5px;left: 10px;">
							<el-button type="primary" :disabled="selectCustomers.length==0" size="small" style="padding: 5px 5px 5px 15px;" @click="sendMsg">
								<span style="vertical-align: top;line-height: 20px;">发送短信</span>
								<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false">
									<div slot="content">
										<div style="text-align: center;margin-bottom: 5px;">短信模板</div>
										<div style="line-height: 20px;">
											尊敬的${name}您好，<br>您所购买的${product}产品，<br>${time}净值为${value}
										</div>
									</div>
									<i class="el-icon-question" style="vertical-align: top;font-size: 20px;color: #606266;margin-left: 5px;"></i>
								</el-tooltip>
							</el-button>
						</div>
						<el-pagination @current-change="customerCurrentPageChangeHandler" background layout="total,prev, pager, next" :total="customerTotal" :page-size="pageSize">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="产品基本信息" name="basicinfo" :style="getStyleObject()">
					<div class="edit-btn-group">
						<el-button @click="startEdit()" size="small" type="primary" icon="el-icon-edit" v-if="isShow">修改</el-button>
					</div>
					<el-form style="margin-top: 10px;" v-show="isShow" :model="product" label-width="120px" size="small" :inline="true" label-suffix=" : ">
						<el-form-item label="产品名称"  style="width: 45%;" class="info-title">
							<label class="info-value">{{product.name}}</label>
						</el-form-item>
						<el-form-item label="产品代码" prop="code" style="width: 45%;" class="info-title">
							<label class="info-value">{{product.code}}</label>
						</el-form-item>
						<el-form-item label="基金经理" prop="manager" style="width: 45%;" class="info-title">
							<label class="info-value">{{product.manager}}</label>
						</el-form-item>
						<!--<el-form-item label="资产管理人" prop="custodian" style="width: 45%;" class="info-title">-->
							<!--<label class="info-value">{{product.custodian}}</label>-->
						<!--</el-form-item>-->
						<el-form-item label="托管人" prop="trustee" style="width: 45%;" class="info-title">
							<label class="info-value">{{product.trustee}}</label>
						</el-form-item>
						<el-form-item label="券商" prop="security" style="width: 45%;" class="info-title">
							<label class="info-value">{{product.security}}</label>
						</el-form-item>
						<el-form-item label="期货公司" prop="futures" style="width: 90%;" class="info-title">
							<label class="info-value">{{product.futures}}</label>
						</el-form-item>
						<el-form-item label="是否前端显示" prop="futures" style="width: 45%;" class="info-title">
							<label class="info-value">{{product.status==1?"不显示":"显示"}}</label>
						</el-form-item>
						<el-form-item label="展示净值" style="width: 45%;" class="info-title">
							<label class="info-value">{{getProductShowCategoryLabel()}}</label>
						</el-form-item>
						<el-form-item label="产品分类" prop="categoryList" style="width: 90%;" class="info-title">
						</el-form-item>
						<div style="padding: 0 40px;box-sizing: border-box;margin-top: -10px;margin-bottom: 10px;">
							<el-table :data="product.categoryList"  header-cell-class-name="table_header" row-key="id" border size="small">
								<el-table-column prop="name" label="名称" width="350px">
									<template slot-scope="scope">
										<label class="info-value">{{scope.row.name}}</label>
									</template>
								</el-table-column>
								<el-table-column prop="code" label="分类代码" width="200px">
									<template slot-scope="scope">
										<label class="info-value">{{scope.row.code}}</label>
									</template>
								</el-table-column>
								<el-table-column prop="description" label="描述">
									<template slot-scope="scope">
										<label class="info-value">{{scope.row.description}}</label>
									</template>
								</el-table-column>

							</el-table>
						</div>
						<el-form-item label="开放日描述" prop="opendayremind" style="width: 90%;" class="info-title">
						</el-form-item>
						<div style="padding: 0 40px;box-sizing: border-box;margin-top: -10px;margin-bottom: 10px;">
							<pre class="info-value" style="white-space: pre-wrap;">{{product.opendayremind}}</pre>
						</div>
						<el-form-item label="产品描述" prop="description" style="width: 90%;" class="info-title">
						</el-form-item>
						<div style="padding: 0 40px;box-sizing: border-box;margin-top: -10px;margin-bottom: 10px;">
							<pre class="info-value" style="white-space: pre-wrap;">{{product.description}}</pre>
						</div>
					</el-form>
					<el-form ref="editForm" v-show="!isShow" :model="editProduct" label-width="120px" size="small" @submit.native.prevent
									 :inline="true" label-suffix=" : " :rules="rules" style="margin-top: 10px;" >
						<el-form-item label="产品名称" prop="name" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.name" style="width: 300px;" placeholder="请输入产品名称"></el-input>
						</el-form-item>
						<el-form-item label="产品代码" prop="code" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.code" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item label="基金经理" prop="manager" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.manager" style="width: 300px;"></el-input>
						</el-form-item>
						<!--<el-form-item label="资产管理人" prop="custodian" style="width: 45%;" class="info-title">-->
							<!--<el-input v-model="editProduct.custodian" style="width: 300px;"></el-input>-->
						<!--</el-form-item>-->
						<el-form-item label="托管人" prop="trustee" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.trustee" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item label="券商" prop="security" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.security" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item label="期货公司" prop="futures" style="width: 45%;" class="info-title">
							<el-input v-model="editProduct.futures" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item label="是否前端显示" style="width: 45%;" class="info-title">
							<el-radio-group v-model="editProduct.status">
								<el-radio-button label="0">显示</el-radio-button>
								<el-radio-button label="1">不显示</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="展示净值" style="width: 45%;" class="info-title">
							<el-select v-model="editProduct.showcategorynetvalue" placeholder="请选择展示的净值"  style="width: 300px;">
								<el-option  :key="0" :label="editProduct.name" :value="0"></el-option>
								<el-option v-for="item in editProduct.categoryList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="产品分类" prop="categoryList" style="width: 90%;" class="info-title" :inline-message="true">
							<el-button type="primary" circle size="small" icon="el-icon-plus" @click="addProductCategoryItem()"></el-button>
						</el-form-item>
						<div class="category-form-item" style="padding: 0 40px;box-sizing: border-box;margin-top: -10px;">
							<el-table :data="editProduct.categoryList"  header-cell-class-name="table_header" row-key="id" border size="small">
								<el-table-column prop="name" label="名称" width="350px">
									<template slot-scope="scope">
										<el-input v-model="scope.row.name"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="code" label="分类代码" width="200px">
									<template slot-scope="scope">
										<el-input v-model="scope.row.code"></el-input>
									</template>
								</el-table-column>
								<el-table-column prop="description" label="描述">
									<template slot-scope="scope">
										<el-input type="textarea" :rows="1" v-model="scope.row.description"></el-input>
									</template>
								</el-table-column>
								<el-table-column label="操作" width="60px">
									<template slot-scope="scope">
										<el-button class="el-button--danger " circle size="mini" icon="el-icon-delete"  @click="removeProductCategoryItem(scope.$index)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-form-item label="开放日描述" prop="opendayremind" style="width: 90%;" class="info-title">
						</el-form-item>
						<div style="padding: 0 40px;box-sizing: border-box;margin-bottom: 10px;margin-top: -10px;" v-if="!isShow" >
							<el-input type="textarea" :rows="20" v-model="editProduct.opendayremind" size="medium" style="min-width: 500px;"></el-input>
						</div>
						<el-form-item label="产品描述" prop="description" style="width: 90%;" class="info-title">
						</el-form-item>
						<div style="padding: 0 40px;box-sizing: border-box;margin-bottom: 10px;margin-top: -10px;" v-if="!isShow" >
							<el-input type="textarea" :rows="20" v-model="editProduct.description" size="medium" style="min-width: 500px;"></el-input>
						</div>
						<div class="bottom-bar">
							<el-button @click="cancelEdit()" size="small" type="danger" icon="el-icon-close" v-if="!isShow">取消修改</el-button>
							<el-button @click="submit()" size="small" type="success" icon="el-icon-check" v-if="!isShow">保存</el-button>
						</div>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="产品开放日" name="opendayinfo" :style="mainStyleObject">
					<div style="padding:0 10px 10px 0;text-align: right;">
						<!--<el-radio-group size="small" v-model="openDayShowType">-->
							<!--<el-radio-button label="日历"></el-radio-button>-->
							<!--<el-radio-button label="表格"></el-radio-button>-->
						<!--</el-radio-group>-->
						<el-button @click="addOpenDay()" size="small" type="primary" icon="el-icon-plus">添加开放日</el-button>
					</div>
					<div style="padding: 0 20px;box-sizing: border-box;margin-bottom: 10px;">
						<el-calendar v-model="today" v-show="openDayShowType=='日历'">
								<template slot="dateCell" slot-scope="{data}">
									<div style="text-align: center;line-height: 40px;">{{data.day.substring(8,10)}}</div>
									<div v-if="isOpenDay(data.day) == 0" class="open-day-item">
										固
									</div>
									<div v-if="isOpenDay(data.day) == 1" class="open-day-item">
										临
									</div>
									<div v-if="isOpenDay(data.day) != -1" class="open-day-item-delete" @click="deleteOpenDayWithDateStr(data.day)">
										<i class="el-icon-delete"></i>
									</div>
								</template>
						</el-calendar>
						<el-table  header-cell-class-name="table_header" row-key="id" border
							:data="openDays" :stripe="true" :height="productOpenDayTableHeight"
											 style="width: 100%" v-show="openDayShowType=='表格'">
							<el-table-column
								prop="openTime"
								label="开放日期" :formatter="dateFormatter">
							</el-table-column>
							<el-table-column
								prop="type" :formatter="openDayTypeFormatter"
								label="类型">
							</el-table-column>
							<el-table-column label="操作" width="140px">
								<template slot-scope="scope">
									<el-tooltip placement="top" popper-class="my-tooltip" :enterable="false" content="发送开放日短信">
										<el-button class="el-button--warning" circle size="mini" icon="el-icon-message"  @click="chooseUserSendMsg(scope.row)"></el-button>
									</el-tooltip>
									<!--<el-button class="el-button&#45;&#45;danger " circle size="mini" icon="el-icon-edit"  @click="updateOpenDay(scope.row)"></el-button>-->
									<el-button class="el-button--danger " circle size="mini" icon="el-icon-delete"  @click="deleteOpenDay(scope.row)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-main>
		<el-dialog title="修改产品净值" :visible.sync="showEditNetPanel">
			<edit-net-panel :product="product" :net-value="updateNetValue" @updatesuccess="updateNetSuccess">

			</edit-net-panel>
		</el-dialog>
		<el-dialog title="添加产品净值" :visible.sync="showAddNetPanel">
			<add-net-panel :net-value="newNetValue" @addsuccess="addNetSuccess">

			</add-net-panel>
		</el-dialog>
		<el-dialog title="开放日" :visible.sync="showUpdateOpenDayPanel">
			<update-open-day-panel @updatesuccess="updateOpenDaySuccess" @addsuccess="addOpenDaySuccess" :open-day="editOpenDay" :product="product"></update-open-day-panel>
		</el-dialog>
		<el-dialog title="选择客户" :visible.sync="showChooseCustomerPanel">
			<choose-customer-panel @onconfirm="confirmChooseCustomer"></choose-customer-panel>
		</el-dialog>
	</el-container>
</template>
<script>
	import config from "../../../config/global.js";
	import axios from "axios"
	import EditNetPanel from "./EditNetPanel.vue"
	import AddNetPanel from "./AddNetPanel.vue"
	import UpdateOpenDayPanel from "./UpdateOpenDayPanel.vue"
	import ChooseCustomerPanel from "../customer/ChooseCustomer.vue"


	var deleteProductNetUrl = config.host+"/backend/product/value/delete.json";
	var downloadExcelUrl = config.host + "/backend/product/value/download";
	var getOpenDayUrl = config.host + "/backend/product/openday/getlist.json";
	var deleteOpenDayUrl = config.host + "/backend/product/openday/delete.json";
	var sendOpenDayMsgUrl = config.host + "/backend/product/sms/opendaysend.json";
	export default {
		components: {
			EditNetPanel,
			AddNetPanel,
			UpdateOpenDayPanel,
			ChooseCustomerPanel
		},
		data() {
			var categoryValidate=(rule, categoryList, callback)=>{
				var validate  = true;
				for(var i=0;i<categoryList.length;i++){
					var category = categoryList[i];
					if(category.name == null || category.name == ""){
						validate = false;
						break;
					}
				}
				if(validate){
					callback();
				}else{
					callback(new Error("分级名称不能为空"))
				}
			};
			return {
				product:{name:''},
				today:new Date(),
				editProduct:{name:''},
				operating:false,
				showAddNetPanel:false,
				showEditNetPanel:false,
				showUpdateOpenDayPanel:false,
				showChooseCustomerPanel:false,
				editOpenDay:{date:""},
				selectOpenDay:null,
				newNetValue:{},
				updateNetValue:{},
				mainStyleObject:{
					"height":window.innerHeight-212+"px",
					"overflow-y":"auto",
					"box-sizing":"border-box"
				},
				editMainStyleObject:{
					"height":window.innerHeight-212+"px",
					"overflow-y":"auto",
					"box-sizing":"border-box",
					"padding-bottom":"50px"
				},
				activeName:"nethistory",
				tableData: [],
				productCustomerTableData:[],
				selectCustomers:[],
				openDays:[],
				total:0,
				customerTotal:0,
				pageSize:50,
				currentPageIndex:1,
				currentCustomerPageIndex:1,
				tableHeight:window.innerHeight-255+"px",
				productCustomerTableHeight:window.innerHeight-245+"px",
				productOpenDayTableHeight:window.innerHeight-270+"px",
				isShow:true,
				changed:false,
				firstchange:false,
				searchTime:"",
				showType:"图",
				openDayShowType:"表格",
				pickerOptions: {
					shortcuts: [{
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							end.setTime(end.getTime()+3600 * 1000 * 24 );
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}}
						,{
						text: '最近半年',
						onClick(picker) {
							const end = new Date();
							end.setTime(end.getTime()+3600 * 1000 * 24 );
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
							picker.$emit('pick', [start, end]);
						}}
						,{
						text: '最近一年',
						onClick(picker) {
							const end = new Date();
							end.setTime(end.getTime()+3600 * 1000 * 24 );
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
							picker.$emit('pick', [start, end]);
						}}]
				},
				rules: {
					name: [
						{ required: true, message: '请输入产品名称', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入产品代码', trigger: 'blur' },
						{ min: 1, max: 50, message: '长度在 1 到 30 个字符', trigger: 'blur' }
					],
					// custodian: [
					// 	{ required: true, message: '请输入资产管理人', trigger: 'blur' },
					// 	{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					// ],
					trustee: [
						{ required: true, message: '请输入托管人', trigger: 'blur' },
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					security:[
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					futures: [
						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
					],
					manager: [
						{ required: true, message: '请输入基金经理', trigger: 'blur' },
						{ min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
					],
					categoryList: [
						{ type:'array',required: true, validator: categoryValidate }
					]
				},
			}
		},
		props:{

		},
		mounted:function(){
			var type = this.$route.query.type;
			var operate = this.$route.query.operate;
			//默认查询近一年的数据
			const end = new Date();
			end.setTime(end.getTime()+3600 * 1000 * 24 );
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
			this.searchTime = [start,end];
			if(type == "net"){
				this.activeName = "nethistory";
				this.getProduct(this.$route.query.id);
				this.getProductNet(this.$route.query.id);

			}else{
				this.activeName = "basicinfo";
				this.getProduct(this.$route.query.id);
			}
			if(operate == "edit"){
				this.isShow = false;
			}
		},
		watch:{
			editProduct:{
				handler:function(){
					if(this.firstchange){
						this.changed = true;
					}
					this.firstchange = true;
				},
				deep:true
			}
		},
		methods:{
			getStyleObject:function () {
				if(this.isShow == false ){
					return this.editMainStyleObject;
				}else{
					return this.mainStyleObject;
				}
			},
			tabBeforeLeave:function (activeName) {
				if(activeName == "nethistory"){
					if(this.isShow == false && this.changed == true){
						this.$confirm('数据已更改，是否放弃修改?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.isShow = true;
							this.$refs.editForm.clearValidate();
							this.activeName="nethistory";
						}).catch(() => {

						});
						return false;
					}else{
						return true;
					}
				}
				return true;
			},
			//获取产品信息
			getProduct(id){
				this.operating=true;
				axios({
					method: 'get',
					url:config.host+'/backend/product/get.json?id='+id
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					if(response.data.result == 1){
						this.product = response.data.object;
						this.editProduct = JSON.parse(JSON.stringify(this.product));
					}else{
						this.$alert(response.data.emsg, '请求失败', {
							confirmButtonText: '确定'
						});
					}
					this.operating = false;
				}).catch((error)=>{
					this.operating = false;
					this.$alert(error.response.statusText, '请求失败', {
						confirmButtonText: '确定'
					});
				})
			},
			//获取产品净值信息
			getProductNet:function (id) {
				if(this.searchTime == null ){
					return;
				}
				var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
				var size = 10000;
				axios({
					method: 'post',
					url: config.host + '/backend/product/value/list.json',
					data: {start, size,type:1,page:true,id:id,startdate:this.searchTime[0],enddate:this.searchTime[1]}
				}).then((response) => {
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					for(var i=0;i<response.data.items.length;i++){
						response.data.items[i].hasChildren = true;
					}
					this.tableData = response.data.items;
					this.total = response.data.total;
					this.drawChart();
				})
					.catch((error) => {
						console.log(error)
					})
			},
			currentPageChangeHandler:function (val) {
				this.currentPageIndex = val;
				this.getProductNet(this.product.id);
			},
			customerCurrentPageChangeHandler:function (val) {
				this.currentCustomerPageIndex = val;
				this.getProductCustomer(this.$route.query.id);
			},
			dataFormatter(row, column, cellValue, index){
				if(typeof cellValue == "number"){
					return cellValue.toFixed(4);
				}else{
					return cellValue;
				}
			},
			valueTimeFormatter(row, column, cellValue, index){
				return cellValue.replaceAll(" 00:00","");
			},
			load(tree, treeNode, resolve){
				axios({
					method: 'post',
					url: config.host + '/backend/product/value/list.json',
					data: {start:0, size:0,type:3,page:false,id:tree.id}
				}).then((response) => {
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					for(var i=0;i<response.data.items.length;i++){
						response.data.items[i].valueTime = response.data.items[i].name
					}
					resolve(response.data.items);
				})
					.catch((error) => {
						console.log(error)
					})
			},
			close(){
				this.$router.back();
			},
			startEdit:function () {
				this.editProduct = JSON.parse(JSON.stringify(this.product));
				this.isShow = false;
				this.firstchange = false;
				this.changed = false;
			},
			submit:function () {
				this.$refs["editForm"].validate((valid) => {
					if (valid) {
						this.operating = true;
						axios({
							method: 'post',
							url:config.host+'/backend/product/update.json',
							data:this.editProduct
						}).then((response)=>{
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							if(response.data.result == 1){
								this.$message({
									message: '保存成功',
									type: 'success'
								});
								this.product = response.data.object;
							}else{
								this.$alert(response.data.emsg, '保存失败', {
									confirmButtonText: '确定'
								});
							}
							this.operating = false;
							this.isShow = true;
						}).catch((error)=>{
							this.operating = false;
							this.$alert(error.response.statusText, '保存失败', {
								confirmButtonText: '确定'
							});
						})
					} else {
						this.$message.error('请正确填写产品信息');
					}
				});
			},
			cancelEdit:function () {
				if(this.changed){
					this.$confirm('数据已更改，是否放弃修改?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.isShow = true;
						this.$refs.editForm.clearValidate();
					}).catch(() => {

					});
				}else{
					this.isShow = true;
					this.$refs.editForm.clearValidate();
				}
			},
			removeProductCategoryItem:function (index) {
				this.$confirm('您确定要删除该类别吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					this.editProduct.categoryList.splice(index,1);
				});
			},
			addProductCategoryItem:function () {
				var newCategory = {name:"",description:""};
				this.editProduct.categoryList.splice(this.editProduct.categoryList.length,0,newCategory);
			},
			switchToGridView:function () {

			},
			switchToChartView:function () {

			},
			popNetView:function(){
				var netValue = {"productId":this.product.id,"valueTime":""};
				var newCategoryList = []
				for(var i=0;i<this.product.categoryList.length;i++){
					var item = this.product.categoryList[i];
					var newItem = {
						productCategoryId:item.id,
						name:item.name,
					}
					newCategoryList.push(newItem);
				}
				netValue.items = newCategoryList;
				this.newNetValue = netValue;
				this.showAddNetPanel = true;
			},
			addNetSuccess:function () {
				this.getProductNet(this.product.id);
				this.showAddNetPanel = false;
			},
			popUpdateNetView:function (netItem) {
				axios({
					method: 'post',
					url: config.host + '/backend/product/value/list.json',
					data: {start:0, size:0,type:3,page:false,id:netItem.id}
				}).then((response) => {
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					var netValue = JSON.parse(JSON.stringify(netItem));
					var newCategoryList = [];
					for(var i=0;i<response.data.items.length;i++){
						var item = response.data.items[i];
						var newItem = {
							productCategoryId:netItem.id,
							name:item.name,
							id:item.id,
							netValue:item.netValue,
							totalPortion:item.totalPortion,
							totalAmount:item.totalAmount,
							totalNetValue:item.totalNetValue
						}
						newCategoryList.push(newItem);
					}
					netValue.items = newCategoryList;
					this.updateNetValue = netValue;
					this.showEditNetPanel = true;
				}).catch((error) => {
					console.log(error)
				})
			},
			deleteNetValue:function(item){
				this.$confirm('您确定要删除该净值记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					axios({
						method: 'post',
						url:deleteProductNetUrl+"?id="+item.id,
						data:{}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '该净值记录已成功删除',
							type: 'success'
						});
						this.getProductNet(this.product.id);
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			updateNetSuccess:function () {
				this.getProductNet(this.product.id);
				this.showEditNetPanel = false;
			},
			drawChart:function () {
				var productNetOptions={
					title:{
						text: "资产份额",
					},
					tooltip : {
						trigger: 'axis'
					},
					calculable : false,
					xAxis : [
					{
						type : 'category',
						axisTick:{
							show:false
						},
						axisLabel:{
							textStyle:{fontSize:10,fontWeight:'bold'}
						},
						axisLine:{
							lineStyle:{
								width:2
							},
						},
						splitLine:{
							show:true
						},
						data : []
					}],
					yAxis : [
					{
						type : 'value',
						scale:true,
						axisTick:{
							show:false
						},
						axisLabel:{
							textStyle:{fontSize:6,fontWeight:'bold'},
							margin:2
						},
						axisLine:{
							lineStyle:{
								width:2
							},
						},
					}],
					series:[]
				};
				var productNetOptions1={
					title:{
						text:"资产净值",
					},
					tooltip : {
						trigger: 'axis'
					},
					calculable : false,
					// dataZoom: [{
					// 	startValue: ''
					// }, {
					// 	type: 'inside'
					// }],
					// toolbox: {
					// 	left: 'center',
					// 	feature: {
					// 		restore: {},
					// 	}
					// },
					xAxis : [
						{
							type : 'category',
							axisTick:{
								show:false
							},
							axisLabel:{
								textStyle:{fontSize:10,fontWeight:'bold'}
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
							splitLine:{
								show:true
							},
							data : []
						}],
					yAxis : [
						{
							type : 'value',
							min:'dataMin',
							max:'dataMax',
							axisTick:{
								show:false
							},
							axisLabel:{
								textStyle:{fontSize:6,fontWeight:'bold'},
								margin:2
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
						}],
					series:[]
				};
				var productNetOptions2={
					title:{
						text: "单位净值",
					},
					tooltip : {
						trigger: 'axis'
					},
					calculable : false,
					// legend: {
					// 	data:['单位净值', '累计净值']
					// },
					// toolbox: {
					// 	left: 'center',
					// 	feature: {
					// 		restore: {},
					// 	}
					// },
					// dataZoom: [{
					// 	startValue: ''
					// }, {
					// 	type: 'inside'
					// }],
					// visualMap: {
					// 	top: 10,
					// 	right: 10,
					// 	precision:1,
					// 	pieces: [{
					// 		gt: 0.5,
					// 		lte: 0.8,
					// 		color: '#096'
					// 	}, {
					// 		gt: 0.8,
					// 		lte: 1.0,
					// 		color: '#ffde33'
					// 	}, {
					// 		gt: 1.0,
					// 		lte: 1.1,
					// 		color: '#ff9933'
					// 	}, {
					// 		gt: 1.1,
					// 		lte: 1.2,
					// 		color: '#cc0033'
					// 	}, {
					// 			gt: 1.2,
					// 			lte: 2,
					// 			color: '#7e0023'
					// 		}],
					// 	outOfRange: {
					// 		color: '#999'
					// 	}
					// },
					xAxis : [
						{
							type : 'category',
							axisTick:{
								show:false
							},
							name:"时间",
							axisLabel:{
								textStyle:{fontSize:10,fontWeight:'bold'}
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
							splitLine:{
								show:true
							},
							data : []
						}],
					yAxis : [
						{
							type : 'value',
							axisTick:{
								show:false
							},
							min:'dataMin',
							max:'dataMax',
							name:"净值",
							axisLabel:{
								textStyle:{fontSize:10,fontWeight:'bold'},
								formatter:function (value,index) {
									return value.toFixed(4);
								}
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
						}],
					series:[]
				};
				var productNetOptions3={
					title:{
						text: "累计净值",
					},
					tooltip : {
						trigger: 'axis'
					},
					calculable : false,
					xAxis : [
						{
							type : 'category',
							axisTick:{
								show:false
							},
							name:"时间",
							axisLabel:{
								textStyle:{fontSize:10,fontWeight:'bold'}
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
							splitLine:{
								show:true
							},
							data : []
						}],
					yAxis : [
						{
							type : 'value',
							axisTick:{
								show:false
							},
							min:'dataMin',
							max:'dataMax',
							name:"净值",
							axisLabel:{
								textStyle:{fontSize:10,fontWeight:'bold'},
								formatter:function (value,index) {
									return value.toFixed(4);
								}
							},
							axisLine:{
								lineStyle:{
									width:2
								},
							},
						}],
					series:[]
				};
				var xAxisData = [];
				var seriesData = {name:"资产份额",type:"line",symbolSize:[5,5],smooth: true,
					markPoint:{data:[{type:'max',name:'最高资产份额'}, {type:"min",name:"最低资产份额"}]},data:[]};
				var seriesData1 = {name:"资产净值",type:"line",symbolSize:[5,5],smooth: true,
					markPoint:{data:[{type:'max',name:'最高资产净值'}, {type:"min",name:"最低资产净值"}]},
					// markLine:{data:[{type:"average",label:"平均资产净值"}],precision:4},
					data:[]};
				var seriesData2 = {name:"单位净值",type:"line",symbolSize:[5,5],smooth: true,
					markPoint:{data:[{type:'max',name:'最高单位净值'}, {type:"min",name:"最低单位净值"}],label:{formatter:this.markPointLabelFormatter}},
					markLine:{label:{show:true,label:"平均资产净值",formatter:this.markPointLabelFormatter},data:[{type:"average",name:"平均资产净值"}]},
					data:[]
				};
				var seriesData3 = {name:"累计净值",type:"line",symbolSize:[5,5],smooth: true,
					markPoint:{data:[{type:'max',name:'最高累计净值'}, {type:"min",name:"最低累计净值"}],label:{formatter:this.markPointLabelFormatter}},
					markLine:{label:{show:true,label:"平均累计净值",formatter:this.markPointLabelFormatter},data:[{type:"average",name:"平均累计净值"}]},
					data:[]};
				for(var i=this.tableData.length-1;i>=0;i--){
					var item = this.tableData[i];
					xAxisData.push(item.valueTime.substring(0,10));
					seriesData.data.push(item.totalPortion);
					seriesData1.data.push(item.totalAmount);
					seriesData2.data.push(item.netValue.toFixed(4));
					seriesData3.data.push(item.totalNetValue.toFixed(4));
				}
				productNetOptions.xAxis[0].data = xAxisData;
				productNetOptions.series = [seriesData];

				productNetOptions1.xAxis[0].data = xAxisData;
				productNetOptions1.series = [seriesData1];

				productNetOptions2.xAxis[0].data = xAxisData;
				productNetOptions2.series = [seriesData2];

				productNetOptions3.xAxis[0].data = xAxisData;
				productNetOptions3.series = [seriesData3];

				var myChart = echarts.init(document.getElementById('productNetChart'));
				var myChart1 = echarts.init(document.getElementById('productNetChart1'));
				var myChart2 = echarts.init(document.getElementById('productNetChart2'));
				var myChart3 = echarts.init(document.getElementById('productNetChart3'));
				myChart.setOption(productNetOptions,true);
				myChart1.setOption(productNetOptions1,true);
				myChart2.setOption(productNetOptions2,true);
				myChart3.setOption(productNetOptions3,true);
			},
			//获取产品客户列表
			getProductCustomer:function (id) {
				var start = Math.max(0,(this.currentCustomerPageIndex-1)*this.pageSize);
				var size = this.pageSize;
				axios({
					method: 'post',
					url: config.host + '/backend/product/customer/list.json',
					data: {start, size,type:1,page:true,productId:id}
				}).then((response) => {
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					for(var i=0;i<response.data.items.length;i++){
						response.data.items[i].hasChildren = true;
					}
					this.productCustomerTableData = response.data.items;
					this.customerTotal = response.data.total;
				})
					.catch((error) => {
						console.log(error)
					})
			},
			//勾选用户
			customerSelectChange:function (val) {
				this.selectCustomers = val;
			},
			sendMsg:function () {
				if(this.selectCustomers.length == 0 ){
					this.$alert("请先选择客户", '提示', {
						confirmButtonText: '确定'
					});
					return;
				}
				this.$confirm('您确定要给客户发送净值短信吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					var data = {};
					data.type = 1;
					axios({
						method: 'post',
						url:config.host+'/backend/product/sms/send.json',
						data:{type:1,customerProductSearchVOList:this.selectCustomers}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '短信已成功发送',
							type: 'success'
						});
						this.$refs.productCustomerTable.clearSelection();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			timeOnPick:function(timePick) {
				this.getProductNet(this.$route.query.id);
			},
			tabOnClick:function (tab) {
				if(this.activeName == "nethistory"){
					this.getProductNet(this.$route.query.id);
				}else if(this.activeName == "productcustomer"){
					this.getProductCustomer(this.$route.query.id);
				}else if(this.activeName == "basicinfo"){
					this.getProduct(this.$route.query.id);
				}else if(this.activeName == "opendayinfo"){
					this.getOpenDays();
				}
			},
			exportExcel:function () {
				if(this.searchTime == null ){
					return;
				}
				var startDate = this.searchTime[0];
				var endDate = this.searchTime[1];
				var url = downloadExcelUrl+"?productid="+this.product.id+"&startdate="+startDate+"&enddate="+endDate;
				window.open(url,"_blank");


				// axios({
				// 	method: 'post',
				// 	url: downloadExcelUrl,
				// 	data: {id:this.product.id,startdate:this.searchTime[0],enddate:this.searchTime[1]}
				// }).then((response) => {
				// 	if(response.status == 200){
				// 		debugger
				// 		var blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
				// 		var fileName = '导出数据.xls';
				// 		if (window.navigator.msSaveOrOpenBlob) {
				// 			navigator.msSaveBlob(blob, fileName);
				// 		} else {
				// 			var link = document.createElement('a');
				// 			link.href = window.URL.createObjectURL(blob);
				// 			link.download = fileName;
				// 			link.click();
				// 			window.URL.revokeObjectURL(link.href);
				// 		}
				// 	}
				// })
				// 	.catch((error) => {
				// 		console.log(error)
				// 	})
			},
			//获取开放日
			getOpenDays:function () {
				var date = new Date();
				axios({
					method: 'get',
					url:getOpenDayUrl+"?productid="+this.product.id+"&date="
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					if(response.data.result == 1){
						this.openDays = response.data.items;
						this.today = new Date();
					}else{
						this.$alert(response.data.emsg, '请求失败', {
							confirmButtonText: '确定'
						});
					}
				}).catch((error)=>{
					this.$alert(error.response.statusText, '请求失败', {
						confirmButtonText: '确定'
					});
				})
			},
			addOpenDay:function () {
				this.editOpenDay = {openTime:"",type:0,remark:""};
				this.showUpdateOpenDayPanel = true;
			},
			addOpenDaySuccess:function () {
				this.getOpenDays();
				this.showUpdateOpenDayPanel = false;
			},
			updateOpenDaySuccess:function () {
				this.getOpenDays();
				this.showUpdateOpenDayPanel = false;
			},
			isOpenDay:function (date) {
				var isOpenDay = -1;
				for(var i=0;i<this.openDays.length;i++){
					var openDay = this.openDays[i];
					if(openDay.openTime.substring(0,10) == date){
						isOpenDay = openDay.type;
						break;
					}
				}
				return isOpenDay;
			},
			// //点击开放日
			// updateOpenDay:function (item) {
			// 	this.editOpenDay =  {"openTime":item.openTime,"type":item.type,"remark":item.remark,"id":item.id};;
			// 	this.showUpdateOpenDayPanel = true;
			// },
			// updateOpenDayWithDateStr:function (dateStr) {
			// 	var editOpenDay = null;
			// 	for(var i=0;i<this.openDays.length;i++){
			// 		var openDay = this.openDays[i];
			// 		if(openDay.openTime.substring(0,10) == dateStr){
			// 			editOpenDay = {"openTime":openDay.openTime,"type":openDay.type,"remark":openDay.remark,"id":openDay.id};
			// 			break;
			// 		}
			// 	}
			// 	if(editOpenDay != null ){
			// 		this.editOpenDay =  {"openTime":openDay.openTime,"type":openDay.type,"remark":openDay.remark,"id":openDay.id};;
			// 		this.showUpdateOpenDayPanel = true;
			// 	}
			// },
			//删除开放日
			deleteOpenDay:function (item) {
				debugger
				this.$confirm('您确定要删除该开放日吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					axios({
						method: 'post',
						url:deleteOpenDayUrl+"?id="+item.id,
						data:{}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '该开放日已成功删除',
							type: 'success'
						});
						this.getOpenDays();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			deleteOpenDayWithDateStr:function (dateStr) {
				this.$confirm('您确定要删除该开放日吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					var editOpenDay = null;
					for(var i=0;i<this.openDays.length;i++){
						var openDay = this.openDays[i];
						if(openDay.openTime.substring(0,10) == dateStr){
							editOpenDay = {"openTime":openDay.openTime,"type":openDay.type,"remark":openDay.remark,"id":openDay.id};
							break;
						}
					}
					if(editOpenDay == null )
						return;
					axios({
						method: 'post',
						url:deleteOpenDayUrl+"?id="+editOpenDay.id,
						data:{}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '该开放日已成功删除',
							type: 'success'
						});
						this.getOpenDays();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			confirmChooseCustomer:function (selectCustomers) {
				this.showChooseCustomerPanel = false;
				var _this = this;
				this.$confirm('您确定要给客户发送短信吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					//将selectCustomer转化为可识别的对象
					var convertCustomers = [];
					for(var i=0;i<selectCustomers.length;i++){
						var selectCustomer = selectCustomers[i];
						convertCustomers.push({"productId":_this.product.id,"customerId":selectCustomer.id,"productOpenDayId":_this.selectOpenDay.id})
					}
					axios({
						method: 'post',
						url:sendOpenDayMsgUrl,
						data:{type:2,customerProductSearchVOList:convertCustomers}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '短信已成功发送',
							type: 'success'
						});
						this.$refs.productCustomerTable.clearSelection();
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			//发送短信
			chooseUserSendMsg:function (item) {
				this.showChooseCustomerPanel = true;
				this.selectOpenDay = item;
			},
			dateFormatter:function (row, column,cellValue,index) {
				if(cellValue.length>10){
					return cellValue.substring(0,10);
				}else{
					return cellValue;
				}
			},
			openDayTypeFormatter:function (row, column,cellValue,index) {
				if(cellValue == 0){
					return "固定开放日";
				}else{
					return "临时开放日";
				}
			},
			markPointLabelFormatter:function (data) {
				var dataValue = data.value;
				return dataValue.toFixed(4);
			},
			getProductShowCategoryLabel:function () {
				if(this.product.categoryList == null || this.product.categoryList == 0 )
					return;
				var showLabel = this.product.name;
				for(var i=0;i<this.product.categoryList.length;i++){
					if(this.product.categoryList[i].id == this.product.showcategorynetvalue){
						showLabel = this.product.categoryList[i].name;
						break;
					}
				}
				return showLabel;
			},
		}
	}
</script>
<style scoped>
	.tl{
		text-align: left;
	}
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}

	.card{
		height: 100%;
		box-sizing: border-box;
		border-radius: 0 0 5px 5px;
	}

	.info-title{
		font-size: 15px;
	}

	.info-value{
		font-size: 13px;
		color: #606266;
	}

	.edit-btn-group{
		position: absolute;
		right: 30px;
		top: 10px;
		z-index: 99;
	}

	.bottom-bar{
		text-align:right;
		height: 32px;
		background:#F5F7FA;
		position: absolute;
		bottom: 0px;
		right:0px;
		left: 0px;
		text-align: right;
		border-radius: 0 0 5px 5px;
		padding: 5px 10px;
		z-index: 999;
		border-top: 1px solid #DCDFE6;
	}

	.group-btn{
		font-size: 20px;
		padding: 4px 7px;
	}

	.wrapper>>>.el-dialog{
		width: 850px;
	}

	.wrapper>>>.el-calendar-table .el-calendar-day{
		height:60px;
		position: relative;
	}

	.wrapper>>>.el-calendar-table thead th{
		padding: 15px 0;
	}

	.wrapper>>>.el-calendar__header{
		padding: 5px 10px;
	}

	.wrapper>>>.el-calendar__body{
		padding: 0px;
	}

	.open-day-item{
		position: absolute;
		top: 2px;
		left: 5px;
		border: 1px solid #FFFFFF;
		width: 25px;
		height: 25px;
		text-align: center;
		line-height: 25px;
		border-radius: 50%;
		background: #409eff;
		color: white;
		font-size: 13px;
		box-shadow:0 2px 4px 0 rgba(232,237,250,.5);
	}

	.open-day-item-delete{
		position: absolute;
		top: 2px;
		right: 5px;
		width: 25px;
		height: 25px;
		text-align: center;
		line-height: 25px;
		font-size: 13px;
		color: red;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/product/ViewProduct.vue